"use client"

import { useMemo } from "react"
import { useI18n } from "@/lib/i18n/LanguageProvider"

export function useAgGridLocaleText() {
  const { t } = useI18n()
  return useMemo(
    () => ({
      noRowsToShow: t("agGrid.noRowsToShow"),
    }),
    [t],
  )
}
